import postscribe from 'postscribe'
import axios from '@/plugins/axios'

export default {
  init (sandbox) {
    return new Promise((resolve, reject) => {
      const element = document.getElementById('payments')
      const callback = {
        done: function () {
          if (sandbox) {
            window.yapay.FingerPrint({ env: 'sandbox' })
            resolve()
          } else {
            window.yapay.FingerPrint()
            resolve()
          }
        },
        error: function (response) {
          // Callback para chamadas que falharam.
          reject(response)
        }
      }
      postscribe(element, '<script src="https://static.traycheckout.com.br/js/finger_print.js" type="text/javascript"></script>', callback)
    })
  },
  getInstallments (estico, card) {
    return new Promise((resolve, reject) => {
      axios.post('payment/yapay/installments/' + estico, { brand: card.brand })
        .then((response) => {
          const installments = []
          response.data.splittings.splitting.forEach(element => {
            installments.push({
              value: element.split,
              text: `${element.split}x de ${parseFloat(element.value_split).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} total: ${parseFloat(element.value_transaction).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} ${parseFloat(element.split_rate) <= 0 ? 'sem juros' : 'com juros'}`
            })
          })
          resolve(installments)
        }).catch((error) => {
          reject(error)
        })
    })
  }
}
